import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SnapshotAlarm } from 'types';

export const getAlarms = async (): Promise<SnapshotAlarm[]> => {
  const { data } = await axios.get(`/api/snapshots/alarms`);
  return data as SnapshotAlarm[];
};

type QueryFnType = typeof getAlarms;

type UseAlarmOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAlarms = ({ config }: UseAlarmOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['alarms'],
    queryFn: getAlarms,
    ...config,
  });
};
